import request from '@/utils/request'

export function login(username, password, code, uuid) {
  return request({
    url: 'auth/login',
    method: 'post',
    hideError: true,
    data: {
      username,
      password,
      code,
      uuid
    }
  })
}

export function getInfo() {
  return request({
    url: 'auth/info',
    method: 'get'
  })
}

export function getCodeImg() {
  return request({
    url: 'auth/code',
    method: 'get',
    hideError: true
  })
}

export function logout() {
  return request({
    url: 'auth/logout',
    method: 'delete'
  })
}
export function getStatistical(orgId) {
  return request({
    url: `/api/v3/statistical/panel/${orgId}`,
    method: 'get'
  })
}
